const AudioFragment = () => ({
  isPlaying: false,
  progress: 1,

  get scale() {
    return this.isPlaying ? 10 : 0;
  },

  playAndStop() {
    this.animateLine();
    const audio = this.$refs.audio;
    if (audio.paused) {
      audio.play();
      this.isPlaying = true;
    } else {
      audio.pause();
      this.isPlaying = false;
    }
  },
  updateProgress() {
    if (this.$refs.audio.paused) return;
    this.progress = this.$refs.audio.currentTime / this.$refs.audio.duration;
  },
  reset() {
    this.progress = 1;
    this.isPlaying = false;
  },

  animateLine() {
    const number1 = Math.random() * 0.08 + 0.001;
    const number2 = Math.random() * 0.008 + 0.001;
    let path = [number1, number2];
    const thisAudioElement = this.$refs.audioButton;
    const thisAudioLineElement = this.$refs.audioButtonLine;
    thisAudioElement.setAttribute('baseFrequency', path);
    thisAudioLineElement.setAttribute('baseFrequency', path);

    requestAnimationFrame(() => {
      const audio = this.$refs.audio;
      if (audio.ended || audio.paused) {
        thisAudioElement.setAttribute('baseFrequency', 0);
        thisAudioLineElement.setAttribute('baseFrequency', 0);
        return cancelAnimationFrame(null);
      }
      setTimeout(() => {
        this.animateLine();
      }, 24);
    });
  }
});

export default AudioFragment;
